import React from 'react'
import TableFooter from '@mui/material/TableFooter'
import parse from 'html-react-parser'
import { TableRowStyled, TableFootStyled } from "../styling/tableStyles";


export default function TableSortFooter(props) { 
  const { footerText, colspan } = props;
  
  return (
    <>
        <TableFooter> 
          <TableRowStyled>
            <TableFootStyled align="center" colSpan={colspan}>
              {parse(footerText)}
            </TableFootStyled>
          </TableRowStyled>
        </TableFooter>
    </>
  )
}